import { expValEquals } from '@atlassian/jira-feature-experiments';

// eslint-disable-next-line jira/ff/inline-usage
export const isCrossTeamPlanningTemplateExperimentEnabled = () =>
	expValEquals('second_premium_template_experiment', 'cohort', 'variation');
